module.exports = "<section class=\"section\">\n  <div class=\"columns is-multiline\">\n    <article *ngFor=\"let item of mainItems\" class=\"column is-4-desktop is-6-tablet tile\" (click)=\"goTo(item.key)\">\n      <div>\n        <h4>{{item.title}}</h4>\n        <div class=\"overlay\"></div>\n        <img [src]=\"item.imageUrl\" alt=\"\">\n      </div>\n    </article >\n  </div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// /mnt/d/Projects/angular/chisparural-foro/src/app/topics/topic-list/topic-list.component.html
// module id = ../../../../../src/app/topics/topic-list/topic-list.component.html
// module chunks = 1